import { useCallback, useMemo, useRef, useState } from "react";
import { Box, Flex } from "@mantine/core"
import { IconPaperclip, IconSend } from "@tabler/icons-react"
import { useSelector } from "react-redux";
import { TFunction } from "i18next";

import { Button, Textarea } from "components"
import { ServiceConstants } from "constant";
import { ChatService } from "services";
import { ChatResponse, UserResponse } from "types";
import { IRootState } from "config/redux";
import DropzoneModal from "./upload";

const { REQUEST_CHATS_MESSAGES_CREATE_ID, REQUEST_PENDING } = ServiceConstants;

interface ChatInputProps {
  chat: ChatResponse;
  loggedUser: UserResponse;
  t: TFunction;
}
const ChatInput = ({ chat, loggedUser, t }: ChatInputProps) => {

  const createServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CHATS_MESSAGES_CREATE_ID]);
  const [dropzoneVisible, setDropzoneVisible] = useState<boolean>(false);
  const textAreaRef = useRef<any>();

  const sendMessage = useCallback(async () => {
    if (!chat) {
      return;
    }
    const message = textAreaRef.current.value;
    const response = await ChatService.chatMessageCreate(chat.user.id, message)
    if (response) {
      textAreaRef.current.value = '';
    }
  }, [chat, loggedUser]);

  const isPosting = useMemo(() => createServiceObject && createServiceObject.status === REQUEST_PENDING,[createServiceObject])

  return (
    <>
      <DropzoneModal chat={chat} opened={dropzoneVisible} onClose={setDropzoneVisible} t={t} />
      <Box bg={'var(--mantine-color-gray-1'}>
        <Flex w={'100%'} align={'flex-start'} pr={'md'}>
          <Button
            variant={'transparent'}
            size={'compact-sm'}
            my={'md'}
            disabled={isPosting}
            onClick={() => setDropzoneVisible(true)}
          >
            <IconPaperclip stroke={1.5} />
          </Button>
          <Textarea
            ref={textAreaRef}
            variant={'unstyled'}
            style={{ flexGrow: 1 }}
            placeholder={t('chat.message.placeholder')}
            my={'sm'}
            mx={'sm'}
            autosize={true}
            minRows={1}
            maxRows={5}
            disabled={isPosting}
          />
          <Button
            variant={'transparent'}
            size={'compact-sm'}
            my={'md'}
            onClick={sendMessage}
            disabled={isPosting}
            loading={isPosting}
          >
            <IconSend stroke={1.5} color={'var(--mantine-color-primary-6'} />
          </Button>
        </Flex>
      </Box>
    </>
  )
}

export default ChatInput;